// Secondary accessory: lowrider chrome rim.
// Used for Bajitos secondaries — the polished spinning rim is the
// lowrider's status object. The spoke pattern + highlight ring reads
// as "freshly polished, mid-rotation."

interface ChromeRimProps {
  /** Rim body color (chrome). */
  bodyColor?: string;
  /** Spoke / hub color (gold accent). */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function ChromeRim({
  bodyColor = '#c0c4ca',
  accentColor = '#d4a945',
  size = 48,
  className,
}: ChromeRimProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Tire — black rubber outer */}
      <circle cx="24" cy="24" r="22" fill="#141008" />
      {/* Sidewall accent */}
      <circle cx="24" cy="24" r="22" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
      {/* Chrome rim — main face */}
      <circle cx="24" cy="24" r="17" fill={bodyColor} />
      {/* Chrome highlight — top-left crescent (specular) */}
      <path
        d="M10 18 Q14 8 24 7 Q22 8 16 14 Q12 18 10 22 Z"
        fill="rgba(255,255,255,0.5)"
      />
      {/* Hub center — gold accent */}
      <circle cx="24" cy="24" r="5" fill={accentColor} />
      {/* Hub bolt center */}
      <circle cx="24" cy="24" r="2" fill={bodyColor} />
      {/* Spokes — 8, radiating from hub to rim edge */}
      <g stroke={accentColor} strokeWidth="2.5" strokeLinecap="round">
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i / 8) * 2 * Math.PI;
          const x1 = 24 + Math.cos(angle) * 6;
          const y1 = 24 + Math.sin(angle) * 6;
          const x2 = 24 + Math.cos(angle) * 16;
          const y2 = 24 + Math.sin(angle) * 16;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
      </g>
      {/* Rim outer edge — bright chrome ring */}
      <circle cx="24" cy="24" r="17" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
    </svg>
  );
}
